<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">Add Insurance</h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-form">
          <z-input v-model="insuranceName" name="insuranceName" label="Insurance Name" />
        </div>
      </template>
      <template #footer>
        <button type="button" class="btn btn-light" @click="close()">Cancel</button>
        <button type="submit" class="btn btn-primary" @click="save()">Save</button>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
export default {
  name: 'DialogInsurance',
  components: {
    ZDialog,
    ZInput
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalSize: null
    }
  },
  emits: ['close', 'save'],
  computed: {
    ...mapState(lookupStore, ['newInsurance']),
    insuranceName: {
      get() {
        return this.newInsurance !== null ? this.newInsurance.insuranceName : null
      },
      set(value) {
        this.setInsurance({
          name: 'name',
          value: value
        })
      }
    },
    isVisible() {
      return this.modelValue ? this.modelValue : false
    }
  },
  methods: {
    ...mapActions(lookupStore, ['setInsurance']),
    close() {
      this.$emit('close')
    },
    async save() {
      if (this.newInsurance.insuranceName != null) {
        this.$emit('save')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-subtitle {
  font-size: 0.9em;
}
.custom-form {
  text-align: left;
  max-height: 200px;
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
